module.exports = __webpack_public_path__ + "static/media/brian.dc46d289.jpg";